export default __webpack_public_path__ + "static/media/csharp.4b8080ff.svg";